import { Point } from '../interface';

function getAngleCount(points: Array<Point>): number {
  let angleCount = 0;

  for (let i = 2; i < points.length - 2; i += 2) {
    const prev: Point = points[i - 2];
    const base: Point = points[i];
    const next: Point = points[i + 2];
    const dx0 = base.x - prev.x;
    const dy0 = base.y - prev.y;
    const dx1 = next.x - base.x;
    const dy1 = next.y - base.y;
    const radian = Math.atan2(dx0 * dy1 - dx1 * dy0, dx0 * dx1 + dy0 * dy1);
    const degree = Math.abs((180 - (radian * 180) / Math.PI) % 360);

    // 110도 이하는 Angle로 친다.
    if ((degree > 180 && 360 - degree < 110) || degree < 130) {
      angleCount++;
    }
  }

  return angleCount;
}

export { getAngleCount };
